<template>
	<v-card flat class="backgroundTransparent">
		<v-card-text>
			<v-text-field
				id="password-email"
				v-model.trim="email"
				outlined
				dense
				filled
				label="Correo electrónico de recuperación"
				type="email"
				prepend-icon="mdi-account"
				required
			/>
		</v-card-text>
		<v-card-actions hide-details>
			<v-btn text color="primary" small @click="back">
				Regresar
			</v-btn>
			<v-spacer></v-spacer>
			<v-btn :loading="loading" small color="primary" @click="onSubmit">
				Solicitar recuperación
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import { mapActions } from 'vuex';

export default {
	props: {
		back: {
			type: Function,
			required: true,
		},
	},
	data() {
		return {
			loading: false,
			email: '',
		};
	},
	methods: {
		async onSubmit() {
			this.loading = true;
			await this.passwordRecover({ email: this.email.toLowerCase() });
			this.loading = false;
		},
		...mapActions({
			passwordRecover: 'User/passwordRecover',
		}),
	},
};
</script>

<style scoped></style>
